var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2765 18.7686H21.295L19.6039 17.0775C19.1452 16.6189 18.8876 15.9968 18.8876 15.3482V11.5464C18.8876 8.40178 16.8779 5.72658 14.0728 4.73512V4.32416C14.0728 2.99458 12.9949 1.91675 11.6654 1.91675C10.3358 1.91675 9.25796 2.99458 9.25796 4.32416V4.73512C6.45287 5.72658 4.44314 8.40178 4.44314 11.5464V15.3482C4.44314 15.9968 4.18549 16.6189 3.72686 17.0775L2.03574 18.7686H8.05425M15.2765 18.7686V19.9723C15.2765 21.9667 13.6597 23.5834 11.6654 23.5834C9.671 23.5834 8.05425 21.9667 8.05425 19.9723V18.7686M15.2765 18.7686H8.05425",
    stroke: "#374151",
    strokeWidth: 2.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.d6c9369d791437ec9118dca60d477986.svg";
export { ForwardRef as ReactComponent };